// extracted by mini-css-extract-plugin
module.exports = {"item":"SignStatus_item__14EW6","signed":"SignStatus_signed__1C3wz","wait":"SignStatus_wait__2XA_l","rejected":"SignStatus_rejected__3lmHf"};